<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user';
    import { validateFields }  from '../base/validation.js';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte'; 
    import TopInfo from '../components/TopInfo.svelte';  
    import Preloader from '../components/Preloader.svelte'; 


    let isLoading = false;

    const fetchPage = async() => {

        if (!$UserStore || !$UserStore.merchant_id){
            push('/login');
            return;
        } 
        
    }


    fetchPage(); 



        
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment p-5">            
            <h1 class="text-[20px] font-bold">
                {$_('shipments.title')}
            </h1>    
            
            <div class="shipment-flex">
                <div class="shipment_origin">                           
                    <div class="">
                        
                        <div class="mb-5 mt-5 bg-slate-100 border-slate-200 border-[1px] p-5 rounded-[5px]">                            
                            {$_('shipments.not_found')}
                        </div>
                                         
                    </div>
                </div> 
            </div> 
        </div>
        
    </div>
</div>

